module.exports = __webpack_public_path__ + "img/PPMP5.df5747f9.png";